<div id="acom">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="inner-card">
                    <h4 class="card-title">Library and eBooks</h4>
                    <div class="card-body text-justify">
                        <p class="lead text-justify inner-lead fw-bold">Nothing is pleasanter than exploring a library.</p>
                       <p class="inner-lead">MPPS possesses a well stocked library which treasures a wide variety of books & support material.
                            It serves as a storehouse of information related to the prescribed syllabus & beyond.
                            The students are encouraged to frequently visit the library & make full use of it. Every class from 4 onwards is allotted one library period per week.</p>
                            <!-- <h5>eBooks</h5>
                            <hr class="pb-1 rounded">
                            <table class="table table-bordered table-hover">
                                <thead>
                                  <tr>
                                    <th scope="col">S.No.</th>
                                    <th scope="col">Book Name</th>
                                    <th scope="col">Link</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <th scope="row">1</th>
                                    <td>Biology - XII</td>
                                    <td><a href="https://ncert.nic.in/textbook.php?lebo1=0-16" target="_blank">https://ncert.nic.in/textbook.php?lebo1=0-16</a></td>
                                  </tr>
                                  <tr>
                                    <th scope="row">2</th>
                                    <td>Biology - XI</td>
                                    <td><a href="https://ncert.nic.in/textbook.php?kebo1=1-22" target="_blank">https://ncert.nic.in/textbook.php?kebo1=1-22</a></td>
                                  </tr>
                                  <tr>
                                    <th scope="row">3</th>
                                    <td>Biology - XI</td>
                                    <td><a href="https://ncert.nic.in/textbook.php?kebo1=1-22" target="_blank">https://ncert.nic.in/textbook.php?kebo1=1-22</a></td>
                                  </tr>
                                </tbody>
                              </table> -->
                              <h5>Biology XII eBooks Link</h5>
                              <hr class="opacity-100">
                              <div class="ranked">
                                  <table class="table table-bordered table-hover">
                                      <thead>
                                        <tr>
                                          <th scope="col">Particular</th>
                                          <th scope="col">Link</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr>
                                          <td>eBook</td>
                                          <td><a href="https://ncert.nic.in/textbook.php?lebo1=0-16">https://ncert.nic.in/textbook.php?lebo1=0-16</a></td>
                                        </tr>
                                      </tbody>
                                    </table>
                              </div>
                              <h5>Biology XI eBooks Link</h5>
                              <hr class="opacity-100">
                              <div class="ranked">
                                  <table class="table table-bordered table-hover">
                                      <thead>
                                        <tr>
                                          <th scope="col">Particular</th>
                                          <th scope="col">Link</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr>
                                          <td>eBook</td>
                                          <td><a href="https://ncert.nic.in/textbook.php?kebo1=0-22">https://ncert.nic.in/textbook.php?kebo1=0-22</a></td>
                                        </tr>
                                      </tbody>
                                    </table>
                              </div>
                              <h5>Chemistry XII eBooks Link</h5>
                        <hr class="opacity-100">
                        <div class="ranked">
                            <table class="table table-bordered table-hover">
                                <thead>
                                  <tr>
                                    <th scope="col">Particular</th>
                                    <th scope="col">Link</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>eBook</td>
                                    <td><a href="https://ncert.nic.in/textbook.php?lech1=0-9">https://ncert.nic.in/textbook.php?lech1=0-9</a></td>
                                  </tr>
                                  <tr>
                                    <td>eBook</td>
                                    <td><a href="https://ncert.nic.in/textbook.php?lech2=0-7">https://ncert.nic.in/textbook.php?lech2=0-7</a></td>
                                  </tr>
                                  
                                </tbody>
                              </table>
                        </div>

                        <h5>Chemistry XI eBooks Link</h5>
                        <hr class="opacity-100">
                        <div class="ranked">
                            <table class="table table-bordered table-hover">
                                <thead>
                                  <tr>
                                    <th scope="col">Particular</th>
                                    <th scope="col">Link</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>eBook</td>
                                    <td><a href="https://ncert.nic.in/textbook.php?kech1=0-7">https://ncert.nic.in/textbook.php?kech1=0-7</a></td>
                                  </tr>
                                  <tr>
                                    <td>eBook</td>
                                    <td><a href="https://ncert.nic.in/textbook.php?kech2=0-7">https://ncert.nic.in/textbook.php?kech2=0-7</a></td>
                                  </tr>
                                  
                                </tbody>
                              </table>
                        </div>
                        <h5>Physics XII eBooks Link</h5>
                        <hr class="opacity-100">
                        <div class="ranked">
                            <table class="table table-bordered table-hover">
                                <thead>
                                  <tr>
                                    <th scope="col">Particular</th>
                                    <th scope="col">Link</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>eBook</td>
                                    <td><a href="https://ncert.nic.in/textbook.php?leph1=0-8">https://ncert.nic.in/textbook.php?leph1=0-8</a></td>
                                  </tr>
                                  <tr>
                                    <td>eBook</td>
                                    <td><a href="https://ncert.nic.in/textbook.php?leph2=0-6">https://ncert.nic.in/textbook.php?leph2=0-6</a></td>
                                  </tr>
                                  
                                </tbody>
                              </table>
                        </div>

                        <h5>Physics XI eBooks Link</h5>
                        <hr class="opacity-100">
                        <div class="ranked">
                            <table class="table table-bordered table-hover">
                                <thead>
                                  <tr>
                                    <th scope="col">Particular</th>
                                    <th scope="col">Link</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>eBook</td>
                                    <td><a href="https://ncert.nic.in/textbook.php?keph1=0-8">https://ncert.nic.in/textbook.php?keph1=0-8</a></td>
                                  </tr>
                                  <tr>
                                    <td>eBook</td>
                                    <td><a href="https://ncert.nic.in/textbook.php?keph2=0-7">https://ncert.nic.in/textbook.php?keph2=0-7</a></td>
                                  </tr>
                                  
                                </tbody>
                              </table>
                        </div>
                              <div id="libraryCarousel" class="carousel slide" data-ride="carousel">
                                <div class="carousel-indicators">
                                  <button type="button" data-bs-target="#libraryCarousel" *ngFor="let img of imgUrl, let i = index" class="{{ (i == 0) ? 'active' : '' }}" data-bs-slide-to="0" aria-current="true" aria-label="Slide 1"
                                  attr.data-bs-slide-to="{{i}}"></button>
                                </div>
                                <div class="carousel-inner text-center py-5 px-3">
                                  <div class="carousel-item" *ngFor="let img of imgUrl, let i=index" [ngClass]="(i == 0 ) ? 'active' : ''">
                                    <a appLazyload href="{{img}}" data-lightbox="Library"><img appLazyload [src]="img" alt="Library" class="img-fluid rounded"></a>
                                  </div>
                                </div>
                                <button class="carousel-control-prev" type="button" data-bs-target="#libraryCarousel" data-bs-slide="prev">
                                  <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                  <span class="visually-hidden">Previous</span>
                                </button>
                                <button class="carousel-control-next" type="button" data-bs-target="#libraryCarousel" data-bs-slide="next">
                                  <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                  <span class="visually-hidden">Next</span>
                                </button>
                              </div>
                    </div>
                </div>

            </div>
        </div>

       
    </div>
</div>